
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorGenericClosed as ObiThreewayAcuatorGenericClosedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-generic-closed.js';
 
 
 

 
 export const ObiThreewayAcuatorGenericClosed = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-generic-closed',
   elementClass: ObiThreewayAcuatorGenericClosedElement,
   events: {
     
   }
  });
 
 